import { render, staticRenderFns } from "./webconfigsetadd.vue?vue&type=template&id=50a183b3&scoped=true"
import script from "./webconfigsetadd.vue?vue&type=script&lang=js"
export * from "./webconfigsetadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a183b3",
  null
  
)

export default component.exports